/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDiyPage {
  pageHeading?: string;
  pageImage?: string;
  pageText?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class DiyActivity extends Component {
  private readonly diyPage: IDiyPage = {
    pageHeading: 'Monster Jam car wash',
    pageImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqB',
    pageText:
      'Whew, those Monster Jam trucks sure do get muddy! Good thing you can clean ‘em off at this DIY car wash. Start with a cardboard box big enough for your monster truck to roll on through and get to designing your car wash. Before you know it, your truck will be sparklin’ clean!',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.diyPage.pageHeading}</h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-image'>
              <img
                className='img-responsive'
                src={this.diyPage.pageImage}
                alt={this.diyPage.pageHeading}
              />
            </div>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-text'>
              <p>{this.diyPage.pageText}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DiyActivity;
